export class EAProperties {
  consumption?: number;
  hasMeterConsumption?: boolean;
  isChecked?: boolean;
  message?: string;
  productId?: string;
  tooltipMessage?: string;
  totalMeterConsumption?: number;
}
